module.exports = __webpack_public_path__ + "static/media/eu_flagge.c2fda179.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/leader/eu_flagge.png
// module id = 834
// module chunks = 1